import { Invoice } from '@/interfaces/invoice';
import { InvoiceResource, invoiceResource } from '@/resources/invoice.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł faktur
 *
 * @export
 * @class InvoiceModule
 * @extends {EntityModule<Invoice, InvoiceResource>}
 */
export class InvoiceModule extends EntityModule<Invoice, InvoiceResource> {
  constructor() {
    super(invoiceResource);
  }
}

export default new InvoiceModule();
